/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {ActionType, createAction} from 'typesafe-actions';
import {
	EmployeeRegistrationPasswordStrengthEvaluationRequestDTO,
	EmployeeRegistrationStateDTO,
	EnterPasswordForEmployeeRegistrationDTO,
	EnterPhoneVerificationCodeForEmployeeRegistrationDTO,
	PasswordStrengthDTO
} from '../../generated/iam-client';
import {ConstraintViolationDTO} from '../../model/validation';

export const confirmEmployeeRegistrationSceneActivated =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_ACTIVATED')();

export const confirmEmployeeRegistrationSceneDeactivated =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_DEACTIVATED')();

export const confirmEmployeeRegistrationSceneStateRetrieved =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_STATE_RETRIEVED')<{ state: EmployeeRegistrationStateDTO }>();

export const confirmEmployeeRegistrationSceneStateNotFound =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_STATE_NOT_FOUND')();

export const confirmEmployeeRegistrationSceneStateUnexpectedError =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_STATE_UNEXPECTED_ERROR')();

export const confirmEmployeeRegistrationSceneRequestRetryPhoneVerification =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_REQUEST_RETRY_PHONE_VERIFICATION')();

export const confirmEmployeeRegistrationSceneRetryPhoneVerificationRequested =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_RETRY_PHONE_VERIFICATION_REQUESTED')();

export const confirmEmployeeRegistrationSceneRetryPhoneVerificationNotFound =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_RETRY_PHONE_VERIFICATION_NOT_FOUND')();

export const confirmEmployeeRegistrationSceneRetryPhoneVerificationUnexpectedError =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_RETRY_PHONE_VERIFICATION_UNEXPECTED_ERROR')();

export const confirmEmployeeRegistrationSceneRequestRestartPhoneVerification =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_REQUEST_RESTART_PHONE_VERIFICATION')();

export const confirmEmployeeRegistrationSceneRestartPhoneVerificationRequested =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_RESTART_PHONE_VERIFICATION_REQUESTED')();

export const confirmEmployeeRegistrationSceneRestartPhoneVerificationNotFound =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_RESTART_PHONE_VERIFICATION_NOT_FOUND')();

export const confirmEmployeeRegistrationSceneRestartPhoneVerificationUnexpectedError =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_RESTART_PHONE_VERIFICATION_UNEXPECTED_ERROR')();

export const confirmEmployeeRegistrationScenePhoneVerificationCodeInputChanged =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_PHONE_VERIFICATION_CODE_INPUT_CHANGED')();

export const confirmEmployeeRegistrationScenePhoneVerificationCodeSubmitted =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_PHONE_VERIFICATION_CODE_SUBMITTED')<{
		command: EnterPhoneVerificationCodeForEmployeeRegistrationDTO
	}>();

export const confirmEmployeeRegistrationScenePhoneVerificationCodeEntered =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_PHONE_VERIFICATION_CODE_ENTERED')();

export const confirmEmployeeRegistrationSceneEnterPhoneVerificationCodeNotFound =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_ENTER_PHONE_VERIFICATION_CODE_NOT_FOUND')();

export const confirmEmployeeRegistrationSceneEnterPhoneVerificationCodeValidationException =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_ENTER_PHONE_VERIFICATION_CODE_VALIDATION_EXCEPTION')<{
		violations: { [key: string]: ConstraintViolationDTO[] }
	}>();

export const confirmEmployeeRegistrationSceneEnterPhoneVerificationCodeUnexpectedError =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_ENTER_PHONE_VERIFICATION_CODE_UNEXPECTED_ERROR')();

export const confirmEmployeeRegistrationScenePasswordInputChanged =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_PASSWORD_INPUT_CHANGED')<{
		evaluationRequest: EmployeeRegistrationPasswordStrengthEvaluationRequestDTO
	}>();

export const confirmEmployeeRegistrationScenePasswordStrengthEvaluated =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_PASSWORD_STRENGTH_EVALUATED')<{ passwordStrength: PasswordStrengthDTO }>();

export const confirmEmployeeRegistrationSceneEvaluatePasswordStrengthNotFound =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_EVALUATE_PASSWORD_STRENGTH_NOT_FOUND')();

export const confirmEmployeeRegistrationSceneEvaluatePasswordStrengthUnexpectedError =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_EVALUATE_PASSWORD_STRENGTH_UNEXPECTED_ERROR')();

export const confirmEmployeeRegistrationScenePasswordSubmitted =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_PASSWORD_SUBMITTED')<{ command: EnterPasswordForEmployeeRegistrationDTO }>();

export const confirmEmployeeRegistrationScenePasswordEntered =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_PASSWORD_ENTERED')();

export const confirmEmployeeRegistrationSceneEnterPasswordNotFound =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_ENTER_PASSWORD_NOT_FOUND')();

export const confirmEmployeeRegistrationSceneEnterPasswordValidationException =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_ENTER_PASSWORD_VALIDATION_EXCEPTION')<{
		violations: { [key: string]: ConstraintViolationDTO[] }
	}>();

export const confirmEmployeeRegistrationSceneEnterPasswordUnexpectedError =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_ENTER_PASSWORD_UNEXPECTED_ERROR')();

export const confirmEmployeeRegistrationSceneStateChanged =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_STATE_CHANGED')<{ state: EmployeeRegistrationStateDTO }>();

export const confirmEmployeeRegistrationSceneBackButtonClicked =
	createAction('CONFIRM_EMPLOYEE_REGISTRATION_SCENE_BACK_BUTTON_CLICKED')();

// noinspection DuplicatedCode
export type ActionTypes =
	ActionType<typeof confirmEmployeeRegistrationSceneActivated> |
	ActionType<typeof confirmEmployeeRegistrationSceneDeactivated> |
	ActionType<typeof confirmEmployeeRegistrationSceneStateRetrieved> |
	ActionType<typeof confirmEmployeeRegistrationSceneStateNotFound> |
	ActionType<typeof confirmEmployeeRegistrationSceneStateUnexpectedError> |
	ActionType<typeof confirmEmployeeRegistrationSceneRequestRetryPhoneVerification> |
	ActionType<typeof confirmEmployeeRegistrationSceneRetryPhoneVerificationRequested> |
	ActionType<typeof confirmEmployeeRegistrationSceneRetryPhoneVerificationNotFound> |
	ActionType<typeof confirmEmployeeRegistrationSceneRetryPhoneVerificationUnexpectedError> |
	ActionType<typeof confirmEmployeeRegistrationSceneRequestRestartPhoneVerification> |
	ActionType<typeof confirmEmployeeRegistrationSceneRestartPhoneVerificationRequested> |
	ActionType<typeof confirmEmployeeRegistrationSceneRestartPhoneVerificationNotFound> |
	ActionType<typeof confirmEmployeeRegistrationSceneRestartPhoneVerificationUnexpectedError> |
	ActionType<typeof confirmEmployeeRegistrationScenePhoneVerificationCodeInputChanged> |
	ActionType<typeof confirmEmployeeRegistrationScenePhoneVerificationCodeSubmitted> |
	ActionType<typeof confirmEmployeeRegistrationScenePhoneVerificationCodeEntered> |
	ActionType<typeof confirmEmployeeRegistrationSceneEnterPhoneVerificationCodeNotFound> |
	ActionType<typeof confirmEmployeeRegistrationSceneEnterPhoneVerificationCodeValidationException> |
	ActionType<typeof confirmEmployeeRegistrationSceneEnterPhoneVerificationCodeUnexpectedError> |
	ActionType<typeof confirmEmployeeRegistrationScenePasswordInputChanged> |
	ActionType<typeof confirmEmployeeRegistrationScenePasswordStrengthEvaluated> |
	ActionType<typeof confirmEmployeeRegistrationSceneEvaluatePasswordStrengthNotFound> |
	ActionType<typeof confirmEmployeeRegistrationSceneEvaluatePasswordStrengthUnexpectedError> |
	ActionType<typeof confirmEmployeeRegistrationScenePasswordSubmitted> |
	ActionType<typeof confirmEmployeeRegistrationScenePasswordEntered> |
	ActionType<typeof confirmEmployeeRegistrationSceneEnterPasswordNotFound> |
	ActionType<typeof confirmEmployeeRegistrationSceneEnterPasswordValidationException> |
	ActionType<typeof confirmEmployeeRegistrationSceneEnterPasswordUnexpectedError> |
	ActionType<typeof confirmEmployeeRegistrationSceneStateChanged> |
	ActionType<typeof confirmEmployeeRegistrationSceneBackButtonClicked>;
